import React from "react";
import {Stack, ToggleButton, ToggleButtonGroup, Typography} from "@mui/material";

/**
 * Bascule « Contrats en cours » Oui/Non (B-001), au format booléen maison du DESIGN.md
 * (ToggleButtonGroup Oui/Non vert/rouge, pas de Switch MUI nu).
 */
const ContratsEnCoursToggle = ({value, onChange, disabled = false}) => (
    <Stack direction="row" spacing={1} alignItems="center">
        <Typography variant="body2">Contrats en cours</Typography>
        <ToggleButtonGroup
            exclusive
            size="small"
            value={value ? "oui" : "non"}
            disabled={disabled}
            onChange={(e, v) => {
                if (v) onChange(v === "oui");
            }}
            aria-label="Contrats en cours"
        >
            <ToggleButton value="oui"
                          className={value ? "toggle-button-small button-selected-green" : "toggle-button-small"}>Oui</ToggleButton>
            <ToggleButton value="non"
                          className={!value ? "toggle-button-small button-selected-red" : "toggle-button-small"}>Non</ToggleButton>
        </ToggleButtonGroup>
    </Stack>
);

export default ContratsEnCoursToggle;
